module.exports = __webpack_public_path__ + "static/fonts/AlibabaPuHuiTi-2-55-Regular.7d731481.ttf";